import React, { useState, useEffect } from 'react';
import { Container, Grid, Tabs, Tab, Box } from '@mui/material';
import { Topheader } from '../../components/Topheader';
import { CreditTab, OneTimeCustomerTab, RefundTab } from './components';

const VirtualTerminal = () => {
  const [isRefundEnabled, setIsRefundEnabled] = useState(true);
  const [openTab, setOpenTab] = useState('credit');

  useEffect(() => {
    getUserPermissions();
  }, []);

  const handleOpenTab = (event, newValue) => {
    setOpenTab(newValue);
  };

  const getUserPermissions = () => {
    let userDetails = localStorage.getItem('user');
    userDetails = JSON.parse(userDetails) || {};
    if (userDetails?._id) {
      setIsRefundEnabled(userDetails.permissions?.refunds || userDetails.permissions?.refundsManual);
    }
  };

  return (
    <div className="rightPanel">
      <Topheader />
      <div className="contentPart">
        <Container component="main" maxWidth={false} className="terminal-container term-add">
          <Grid container rowSpacing={3} columnSpacing={3} alignItems={'flex-start'}>
            <Grid item xs={12} />
            <Grid item xs={12}>
              <h3 className="terminal-title">Virtual Terminal</h3>
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={openTab} onChange={handleOpenTab}>
                  <Tab id="tab-credit" value="credit" label="Credit" />
                  <Tab id="tab-onetime" value="onetime" label="One Time Customer" />
                  <Tab id="tab-refund" value="refund" label="Refund" disabled={!isRefundEnabled} />
                </Tabs>
              </Box>
            </Grid>
            <Grid item xs={12}>
              {openTab === 'credit' && <CreditTab />}
              {openTab === 'onetime' && <OneTimeCustomerTab />}
              {openTab === 'refund' && <RefundTab />}
            </Grid>
          </Grid>
        </Container>
      </div>
    </div>
  );
};

export default VirtualTerminal;
